import * as React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { classes } from '../../utils/Classes';
import { translate, ITranslationsCollection } from 'elc-service';
import { Body1 } from 'elc-typography';
import { FavoritesIcon } from './FavoritesIcon';

export interface IFavoriteButtonProps {
    translations?: ITranslationsCollection;
    isFavorite: boolean;
    handleFavoriteClick(): void;
}

const Wrapper = styled.button`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const FavoriteButton = translate(['addToFavoritesLabel'])(
    observer((props: IFavoriteButtonProps) => {
        const { isFavorite, handleFavoriteClick } = props;
        const { addToFavoritesLabel } = props.translations as ITranslationsCollection;
        const buttonClass = classes('favorite-button');

        return (
            <Wrapper className={buttonClass} onClick={handleFavoriteClick}>
                <FavoritesIcon isFavorite={isFavorite} />
                <Body1>{addToFavoritesLabel}</Body1>
            </Wrapper>
        );
    })
);
